export const listQueueNamesRedux = (
  actionType: string,
  
) => {
  window.parent.primingcloudRedux.queue.listQueueNames(
    actionType
  )
}

export const listQueueThingsRedux = (
  queueName: string,
  actionType: string,
  
) => {
  window.parent.primingcloudRedux.queue.listQueueThings(
    queueName,
    actionType
  )
}

export const listQueuePartitionsRedux = (
  queueName: string,
  thingId: number,
  actionType: string
) => {
    window.parent.primingcloudRedux.queue.listQueuePartitions(
      queueName,
      thingId,
      actionType
    )
}

export const loadQueueDataRedux = (
  queueName: string,
  thingId: number,
  partition: number,
  startBucket: number,
  startTimestamp: number,
  startUid: number,
  limit: number,
  actionType: string,
  
) => {
    window.parent.primingcloudRedux.queue.loadQueueData(
      queueName,
      thingId,
      partition,
      startBucket,
      startTimestamp,
      startUid,
      limit,
      actionType,
      
    )
}

export const deleteQueueEntryRedux = (
  queueName: string,
  thingId: number,
  partition: number,
  bucket: number,
  timestamp: number,
  uid: number,
  actionType: string,
  
) => {
    window.parent.primingcloudRedux.queue.deleteQueueEntry(
      queueName,
      thingId,
      partition,
      bucket,
      timestamp,
      uid,
      actionType,
      
    )
}
